import React from 'react';

import logger from 'utils/logger';

import ItinerariesItemHeader from './ItinerariesItemHeader';
import PageHeader from './PageHeader';
import SettingsHeader from './SettingsHeader';
import { Wrapper } from './Wrapper';

function Header(props) {
  const { type } = props;

  if (type === 'page') {
    return (
      <Wrapper>
        <PageHeader />
      </Wrapper>
    );
  }

  if (type === 'settings') {
    return (
      <Wrapper>
        <SettingsHeader />
      </Wrapper>
    );
  }

  if (type === 'itinerariesItem') {
    return (
      <Wrapper>
        <ItinerariesItemHeader />
      </Wrapper>
    );
  }

  logger.error(`[${Header.name}] unknown page type supplied: '${type}'`);
  return null;
}

export default Header;
